// import request from '@/router/axios'
import { request } from '@/network/request'
import store from "@/store";
export function getOtherFile(id,type) {
  return request({
    url: '/gaoligong/picturevideo/getPictureVideoFileList',
    method: 'get',
    params: {
      id,
      type,
    },
  })
}
//文件上传
export function handleUploads(form) {
  const token = store.state.access_token
  return request({
    url: '/admin/sys-file/uploads',
    method: 'post',
    formData: form,
    data:form,
    headers:{
      'Content-Type':'multipart/form-data',
      'Authorization': 'bearer ' + token,
    }
  })
}

export function handleUpload(form) {
  const token = store.state.access_token
  return request({
    url: '/admin/sys-file/upload',
    method: 'post',
    formData: form,
    data:form,
    headers:{
      'Content-Type': "multipart/form-data",
      'Authorization': 'bearer ' + token,
    }
  })
}
export function delFile(id) {
  const token = store.state.access_token
  return request({
    url: '/admin/sys-file/' + id,
    method: 'delete',
    headers:{
      'Authorization': 'bearer ' + token,
    }
  })
}


export function getFile(bucket,fileName,folderName) {
  const token = store.state.access_token
  return request({
    url: '/admin/sys-file/getFile',
    method: 'post',
    data: {
      bucket,fileName,folderName
    },
    headers:{
      'Authorization': 'bearer ' + token,
    }
  })
}